import axios from "axios";
import env from "../env";
var HttpClient = /** @class */ (function () {
    function HttpClient() {
    }
    HttpClient.prototype.submitOverride = function (overrideInstance) {
        return axios.post("".concat(env.CASB_API_URL, "/overrides"), overrideInstance, {
            headers: {
                'Content-Type': 'application/json',
            },
        });
    };
    return HttpClient;
}());
var httpClient = new HttpClient();
export default httpClient;
